import React, { useState, useRef, useEffect } from 'react'
import { IProps } from '../../components/did-you-know/Interface'
import { useOutsideClick } from 'utils'
import { DidYouKnow } from 'components'
import { Grid } from '@material-ui/core'

type DidYouKnowEditingState = 'IDLE' | 'MOUSE_ENTERED' | 'FOCUSED' | 'CLICKED_TO_EDIT'

const ComplexDidYouKnowComponent: React.FC<IProps> = ({
  answerTitle,
  answer,
  corner,
  disabled,
  questionKey,
  error,
  ...props
}) => {
  const [isEditing, setIsEditing] = useState<DidYouKnowEditingState>('IDLE')
  const [clickOutSide, setClickOutSide] = useState(false)
  const refGrid = useRef()
  const refInputTitle = useRef()

  const title = answerTitle ? `${answerTitle}` : ''
  const detail = answer || ''
  const answerComplete = title.length && detail.length ? `${title}: ${detail}` : null

  useEffect(() => {
    if (answerComplete && isEditing !== 'IDLE' && clickOutSide) {
      setIsEditing('IDLE')
      setClickOutSide(false)
    }
  }, [answerComplete, clickOutSide])

  useEffect(() => {
    if (isEditing === 'FOCUSED') {
      if (refInputTitle.current) {
        // @ts-ignore: Object is possibly 'null'
        refInputTitle.current.focus()
      }
    }
  }, [isEditing])

  useOutsideClick(refGrid, () => {
    if (isEditing) {
      setClickOutSide(true)
    }
  })

  const onReadInputFocus = () => {
    if (!disabled && isEditing === 'IDLE') {
      setIsEditing('FOCUSED')
      setClickOutSide(false)
    }
  }

  const onEditAreaMouseEnter = () => {
    if (!disabled && isEditing === 'IDLE') {
      setIsEditing('MOUSE_ENTERED')
    }
  }

  const onEditAreaMouseLeave = () => {
    if (!disabled && isEditing === 'MOUSE_ENTERED') {
      setIsEditing('IDLE')
    }
  }

  return (
    <Grid ref={refGrid}>
      <div onMouseEnter={onEditAreaMouseEnter} onMouseLeave={onEditAreaMouseLeave}>
        {isEditing === 'IDLE' && answerComplete !== null && (
          <DidYouKnow
            onInputClick={() => {
              if (!Boolean(disabled)) {
                setIsEditing('CLICKED_TO_EDIT')
                setClickOutSide(false)
              }
            }}
            onFocus={onReadInputFocus}
            questionKey={questionKey}
            title={'A personal statistic'}
            answer={answerComplete}
            corner={corner}
            bgColor={'#F26723'}
            disabled={disabled}
            error={error}
          />
        )}
        {(isEditing !== 'IDLE' || answerComplete === null) && (
          <DidYouKnow
            onInputClick={() => {
              if (!Boolean(disabled)) {
                setIsEditing('CLICKED_TO_EDIT')
              }
            }}
            onInputTitleClick={() => {
              if (!Boolean(disabled)) {
                setIsEditing('CLICKED_TO_EDIT')
              }
            }}
            questionKey={questionKey}
            disabled={disabled}
            answer={answer}
            corner={corner}
            answerTitle={answerTitle}
            inputRefTitle={refInputTitle}
            error={error}
            {...props}
          />
        )}
      </div>
    </Grid>
  )
}

export default ComplexDidYouKnowComponent
